var _ArrowIosLeft;
import ArrowIosLeft from '@crehana/compass.icons.outline/ArrowIosLeft';
import { useMediaQuery } from '@crehana/react-hooks';
import { cx } from 'class-variance-authority';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Breadcrumb = function Breadcrumb(_ref) {
  var items = _ref.items,
    className = _ref.className,
    _ref$disableFirstItem = _ref.disableFirstItem,
    disableFirstItem = _ref$disableFirstItem === void 0 ? false : _ref$disableFirstItem,
    classNameItem = _ref.classNameItem;
  var _useMediaQuery = useMediaQuery('sm'),
    isSm = _useMediaQuery.matches;
  var returnClassText = function returnClassText(isLastItem) {
    if (isLastItem) {
      if (classNameItem) {
        return classNameItem;
      }
      return 'tw-text-neutral-light-800 dark:tw-text-neutral-light-100';
    }
    return 'tw-text-neutral-light-700 dark:tw-text-neutral-dark-300';
  };
  if (items.length === 0) {
    return null;
  }
  if (!isSm) {
    var previousItem = items.length > 1 ? items[items.length - 1] : items[0];
    return /*#__PURE__*/_jsxs("button", {
      type: "button",
      onClick: previousItem.onClick,
      className: cx('tw-flex tw-gap-0.4 tw-items-center tw-text-primary-light-500 tw-font-body4 dark:tw-text-secondary-light-500', className),
      children: [_ArrowIosLeft || (_ArrowIosLeft = /*#__PURE__*/_jsx(ArrowIosLeft, {
        size: 24,
        className: "tw-min-w-2.4"
      })), previousItem.label]
    });
  }
  return /*#__PURE__*/_jsx("div", {
    className: cx('tw-flex tw-gap-0.8', className),
    children: items.map(function (_ref2, index) {
      var label = _ref2.label,
        onClick = _ref2.onClick;
      var isLastItem = index === items.length - 1 && items.length > 1;
      var isDisabled = disableFirstItem && index === 0;
      return /*#__PURE__*/_jsx("button", {
        type: "button",
        onClick: onClick,
        disabled: isDisabled,
        className: cx('tw-font-body4 tw-transition-colors tw-duration-400 tw-ease-in-out', !isDisabled && 'hover:tw-text-primary-light-600', returnClassText(isLastItem),
        // Slash separator for all items except the last one
        !isLastItem && 'after:tw-content-["/"] after:tw-text-neutral-light-700 after:tw-font-body5 after:tw-ml-0.8'),
        children: label
      }, label);
    })
  });
};
export default Breadcrumb;